import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { UserState } from '../store/user.state';

@Injectable()
export class FrontierGuard implements CanActivate {

    constructor(private store: Store,
                private router: Router,
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.store.selectSnapshot(UserState.getUser)?.frontierAccess) {
            return true;
        }
        this.router.navigate(['/']);
        return false;
    }
}
